import { SentryEnvironments } from '@anchorage/sentry';

// The data-testid to use for any error boundaries
export const ERROR_FOUND_TESTID = 'error-found';

// Returns true if running in production environment
export const isProduction =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'anchoragelogin.com' ||
    window.location.hostname === 'dashboard.porto.xyz');

// Contact email for API questions
export const API_CONTACT_EMAIL = 'api@anchorage.com';

export const REACT_SELECT_NONCE =
  'OWRjNmFhNDQtZGQxNy00ZDEwLTgxMzItMjU5Y2QxYzVlMTc2';

// local storage key for porto login acknowledged
export const PORTO_LOGIN_ACKNOWLEDGED_KEY_NAME = 'portoLoginAcknowledged';

// Environments
export const NODE_ENV = {
  PROD: 'production',
  DEV: 'development',
};

/**
 * Get LaunchDarkly client-side ID based on environment.
 * Frontoffice and backoffice share the same LaunchDarkly project/account.
 * Flag names are prefixed (FO_* vs BO_*) to distinguish between apps.
 *
 * These are LaunchDarkly client-side IDs (safe to commit, not secret keys).
 *
 * @returns LaunchDarkly client-side ID for the current environment
 */
export function getLaunchDarklyEnvOptions() {
  const sentryEnvironment =
    typeof window !== 'undefined'
      ? // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        (window as any).env?.SENTRY_ENVIRONMENT
      : undefined;

  switch (sentryEnvironment) {
    case SentryEnvironments.STAGING:
      return {
        clientSideId: '6826124fa4f18b092efed6fc',
      };
    case SentryEnvironments.PRODUCTION:
      return {
        clientSideId: '681e6ab84dbfa60ddf1f3a43',
      };
    default:
      return {
        clientSideId: '68261247a4f18b092efed6b0',
      };
  }
}

// Mixpanel
const getMixpanelOptions = () => {
  const defaultToken = 'ab7b3cfe55ce788636434e53671f9cee';

  if (typeof window !== 'undefined') {
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    switch ((window as any).env?.SENTRY_ENVIRONMENT) {
      case SentryEnvironments.STAGING:
        return {
          token: '0750790e29a5f19377d60b784ccc952f',
        };
      case SentryEnvironments.PRODUCTION:
        return {
          token: 'df77b736dd9614136248ae018d3fad60',
        };
      default:
        return {
          token: defaultToken,
        };
    }
  } else {
    return {
      token: defaultToken,
    };
  }
};

export const MIXPANEL_OPTIONS = {
  debug: false,
  ...getMixpanelOptions(),
};

export enum ORG_OPERATOR_TYPES {
  SELF = 'SELF',
  ANCHORAGE = 'ANCHORAGE',
}

export const isPortoOperator = (operator: string | null | undefined): boolean =>
  operator === (ORG_OPERATOR_TYPES.SELF as string);
